import { render, staticRenderFns } from "./ProductACVTexts.vue?vue&type=template&id=47ddd875&scoped=true&"
import script from "./ProductACVTexts.vue?vue&type=script&lang=js&"
export * from "./ProductACVTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ddd875",
  null
  
)

export default component.exports